import { createSelector } from 'reselect';

import getPageData from 'shared/modules/page/selectors/getPageData';
import isLoginLinkExternal from 'shared/modules/page/helpers/isLoginLinkExternal';

export default createSelector([getPageData], isLoginLinkExternal);
